$(document).ready(function () {
    new Swiper('.csw .csw-items.swiper-container', {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 12,
        pagination: {
            el: '.csw .swiper-pagination',
            clickable: true,
        },
        scrollbar: {
            el: '.csw .swiper-scrollbar',
            draggable: true,
        },
        navigation: {
            nextEl: '.csw .swiper-next-btn',
            prevEl: '.csw .swiper-prev-btn',
        },
        breakpoints: {
            819: {
                spaceBetween: 12,
                slidesPerView: 2,
            },
            1279: {
                spaceBetween: 16,
                slidesPerView: 3,
            },
            1920: {
                slidesPerView: 4,
            }
        }
    });
});